/*
  RA Boutique - fullscreen Hairboomb legacy disattivato.
  Il viewer attivo e' snippets/ra-hb-video-fullscreen.liquid.
  Questo asset resta presente solo per compatibilita con il riferimento del tema.
*/
(()=>{window.__raHairboombLegacyFullscreenDisabled=true;})();
